import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../../components/hooks/useFetch';
import Input from '../../../../components/form/Input';
import { getIPAddress } from '../../../../components/utils/GetIPAddress';
import { CONTRATO_AUTORIZADO_PERMISSIONARIO } from '../../../../services/delegacaoTerceiro';
import { PESQUISAR_CONTRATOS_PJ } from '../../../../services/delegacao';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';

const FormPermissaoContrato = ({ acaoCancelar, dados, terceiro }) => {
  const methods = useForm({});
  const [itensAutorizados, setItensAutorizados] = useState([]);
  const [montarContratos, setMontarContratos] = useState(false);

  const [ipAddress, setIpAddress] = useState('');
  const { request } = useFetch();
  const { request: requestContrato, data: dadosContrato } = useFetch();
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  useEffect(() => {
    setMontarContratos(false);
    requestContrato(PESQUISAR_CONTRATOS_PJ(dados.idCorreios, dados.tipo));
  }, [terceiro]);

  useEffect(() => {
    if (terceiro?.contratos) {
      var dadosAutorizados;
      if (itensAutorizados == undefined) {
        dadosAutorizados = [];
      } else {
        dadosAutorizados = itensAutorizados;
      }
      dadosContrato?.forEach((contrato, i) => {
        const existe = terceiro.contratos.some(
          (terceiro) =>
            terceiro.nuContrato.trim() === contrato.nuContrato.trim() &&
            terceiro.se === contrato.nuSe,
        );
        dadosAutorizados[i] = existe;
      });
      setItensAutorizados(dadosAutorizados);
    } else {
      setItensAutorizados(dadosContrato?.map(() => false));
    }
    if (dadosContrato) setMontarContratos(true);
  }, [terceiro]);
  const cancelar = () => {
    acaoCancelar();
  };
  const handleCheckBoxChange = (id) => {
    const atualizaItensMarcados = [...itensAutorizados];
    atualizaItensMarcados[id] = !atualizaItensMarcados[id];
    setItensAutorizados(atualizaItensMarcados);
  };
  const autorizar = async () => {
    var autorizacoes = [];
    itensAutorizados.forEach((item, i) => {
      autorizacoes[i] = {
        idCorreios: dados.idCorreios,
        idCorreiosPF: terceiro.idCorreiosPF,
        nuContrato: dadosContrato[i].nuContrato,
        se: dadosContrato[i].nuSe,
        autoriza: item,
        tipo: dados.tipo,
      };
    });

    const { response } = await request(
      CONTRATO_AUTORIZADO_PERMISSIONARIO(autorizacoes, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog('Autorizacao efetuada com sucesso.');
    }
    acaoCancelar();
  };
  return (
    <>
      {dadosContrato?.length === 0 || dadosContrato == undefined ? (
        <h6>Não foram encontrados contratos para autorizar</h6>
      ) : (
        <>
          <h6>Selecione os Contratos que deseja autorizar</h6>
          <div className="dialog-main">
            {montarContratos && (
              <>
                {dadosContrato?.map((item, index) => (
                  <div className="toggle-container">
                    <label className="toggle">
                      <Input
                        className="toggle-checkbox esconder-visualmente"
                        type="checkbox"
                        name={item.nuContrato}
                        onChange={() => handleCheckBoxChange(index)}
                        checked={itensAutorizados[index] || false}
                        {...formMethods}
                      />
                      <div className="toggle-switch"></div>
                      <span className="toggle-label">
                        Contrato nº {item.nuContrato}
                        {item.nuSe}
                      </span>
                    </label>
                  </div>
                ))}
              </>
            )}
          </div>
        </>
      )}
      <div className="dialog-footer btns-row-fixo">
        <button className="btn-txt btn-fecha-dialog" onClick={() => cancelar()}>
          Cancelar
        </button>
        {dadosContrato?.length > 0 && (
          <button className="btn-pre btn-com-icone" onClick={() => autorizar()}>
            <i className="ic-usuario-visto"></i>
            Autorizar
          </button>
        )}
      </div>
    </>
  );
};
export default FormPermissaoContrato;
